// filepath: /C:/Users/nitis/Desktop/uii/client/src/recruiter Components/nav Components/PostedJobs.js
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import NavHeader from '../shared/Nav-Header';
import styles from './posted-jobs.module.css';

const PostedJobs = () => {
    const [jobs, setJobs] = useState([]);
    const [notification, setNotification] = useState('');
    const [pfp, setPfp] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchJobs = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    localStorage.setItem('notification', 'Please login first');
                    navigate('/recruiter/login');
                    return;
                }

                const response = await axios.get('/api/recruiter/jobs/live-posted-jobs', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setJobs(response.data);
            } catch (error) {
                console.error('Error fetching jobs:', error);
            }
        };

        fetchJobs();
    }, [navigate]);

    useEffect(() => {
        const fetchpfp = async () => {
            try {
                const token = localStorage.getItem('token');
                if (!token) {
                    localStorage.setItem('notification', 'Please login first');
                    navigate('/recruiter/login');
                    return;
                }

                const response = await axios.get('/api/company/the-company-pfp', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                setPfp(response.data);
            } catch (error) {
                console.error('Error fetching jobs:', error);
            }
        };

        fetchpfp();
    }, [navigate]);

    const handleStatusChange = async (jobId, fromStatus, toStatus) => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.put('/api/recruiter/jobs/update-job-status', {
                jobId,
                fromStatus,
                toStatus
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setNotification(response.data.message);
            setJobs(jobs.map(job => job._id === jobId ? { ...job, status: toStatus } : job));
        } catch (error) {
            console.error('Error updating job status:', error);
            setNotification('Error updating job status. Please try again.');
        }
    };

    const handleJobClick = (jobId) => {
        navigate(`/recruiter/job-details/${jobId}`);
    };

    return (
        <div>
            <NavHeader />
            <div className={styles.allJobsContainer}>
                <div className={styles.jobDetailsHeader}>
                    <img src={pfp? pfp.replace('/upload/', '/upload/w_192,h_200,c_fill/') 
                    : '/default-profile.png'}
                    alt="Company Logo" className={styles.companyLogo} />
                    <h2>Posted Jobs</h2>
                </div>
                {notification && <p className={styles.notification}>{notification}</p>}
                <div className={styles.tableWrapper}>
                    <table className={styles.jobsTable}>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Location</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {jobs.map(job => (
                                <tr key={job._id} onClick={() => handleJobClick(job._id)}>
                                    <td data-label="Title">{job.title}</td>
                                    <td data-label="Location">{job.location}</td>
                                    <td data-label="Status">
                                        {job.status}
                                        <span className={styles.statusDot} style={{ backgroundColor: "limegreen" }}></span>                                    
                                    </td>
                                    <td data-label="Actions">
                                        <select className={styles.select}
                                            value={job.status}
                                            onChange={(e) => handleStatusChange(job._id, job.status, e.target.value)}
                                            onClick={(e) => e.stopPropagation()} // Prevent row click when changing status
                                        >
                                            <option value="liveJobs">Start Applications</option>
                                            <option value="hiddenJobs">Hide Job</option>
                                            <option value="pausedJobs">Stop Applications</option>
                                            <option value="draftJobs">Save in Drafts</option>
                                            <option value="deletedJobs">Delete Job</option>
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default PostedJobs;